var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emptyData"},[_c('img',{attrs:{"src":"https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/coll_qs.png","alt":""}}),_c('p',[_vm._v(_vm._s(_vm.txtcont))])])
}
var staticRenderFns = []

export { render, staticRenderFns }